import React, { useState } from 'react';
import { useEffect } from 'react';
import { data } from './Board.js';
import '../styles/ThemeMode.css'
import {HiLightBulb} from 'react-icons/hi'

function ThemeMode(props) {

    const {toggleTheme} = props;
    

    return (
        <div className='theme-but-div'>
            <button className='btn-primary' onClick={toggleTheme}>
                <HiLightBulb size={20} />
            </button>
        </div>
    );
}

export default ThemeMode;